const Reflux = require("reflux");

export const ImportActions = Reflux.createActions([ "import" ]);
